import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";
import { WidgetsTypeEnum } from "src/app/enums/widgets/widgets-type.enum";
import { WidgetsAbstract } from "./widgets.abstract";

export abstract class WidgetsComponentAbstract {
    // TODO: Enum originally named in Uppercase
    // eslint-disable-next-line
    WidgetsTypeEnum = WidgetsTypeEnum;

    isMinimized: boolean = true;
    metadataView: boolean = false;
    abstract data: WidgetsAbstract;

    // onDelete() {}

    onMinimize() {
        this.isMinimized = true;

    }
    onMaximize() {
        this.isMinimized = false;

    }
    setMetadataView(value: boolean) {
        this.metadataView = value;
    }
    isMetadataView(): boolean {
        return this.metadataView;
    }

    abstract clone(widgetsAbstract): WidgetsAbstract;
}
